<template>
  <div id="AddCourse" class="well" style="padding: 0 1em">
    <div>
      <button
        href="#"
        @click.prevent="close()"
        class="btn btn-outline-secondary"
        type="button"
        style="font-size: 14px"
      >
        回課程列表
      </button>
    </div>
    <div class="form-group">
      <table class="table" style="width: 100%; align: left">
        <tbody style="width: 70%; align: left">
          <tr style="width: 70%; align: left">
            <td>
              <div>
                <span class="red_star">＊</span><span>屬性類別：</span
                ><span
                  ><b-form-select
                    class="form-control"
                    id="cidSelectText"
                    v-model="selected"
                    ref="selected"
                    @change="UpdateCid()"
                    :options="options"
                  >
                  </b-form-select
                ></span>
              </div>
            </td>
          </tr>
          <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>課程名稱:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.courseName"
                  ref="inputData.courseName"
                  placeholder="課程名稱"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                <span class="red_star">＊</span><span>課程開始日期：</span>
                <span>
                  <div>
                    <b-input-group class="mb-3">
                      <b-form-input
                        v-model="inputData.sdate"
                        ref="inputData.sdate"
                        type="text"
                        placeholder="YYYY-MM-DD"
                        autocomplete="off"
                        required
                      ></b-form-input>

                      <b-input-group-append>
                        <b-form-datepicker
                          v-model="inputData.sdate"
                          button-only
                          right
                          locale="zh-tw"
                          aria-controls="example-input"
                          @context="onContext"
                        ></b-form-datepicker>
                      </b-input-group-append>
                    </b-input-group></div
                ></span>
              </div>

              <div>
                <span class="red_star">＊</span><span>課程結束日期：</span>
                <span>
                  <div>
                    <b-input-group class="mb-3">
                      <b-form-input
                        v-model="inputData.edate"
                        ref="inputData.edate"
                        type="text"
                        placeholder="YYYY-MM-DD"
                        autocomplete="off"
                        required
                      ></b-form-input>

                      <b-input-group-append>
                        <b-form-datepicker
                          v-model="inputData.edate"
                          button-only
                          right
                          locale="zh-tw"
                          aria-controls="example-input"
                          @context="onContext"
                        ></b-form-datepicker>
                      </b-input-group-append>
                    </b-input-group></div
                ></span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                <span class="red_star">＊</span><span>報名截止日期：</span>
                <span>
                  <div>
                    <b-input-group class="mb-3">
                      <b-form-input
                        v-model="inputData.closeDate"
                        ref="inputData.closeDate"
                        type="text"
                        placeholder="YYYY-MM-DD"
                        autocomplete="off"
                        required
                      ></b-form-input>

                      <b-input-group-append>
                        <b-form-datepicker
                          v-model="inputData.closeDate"
                          button-only
                          right
                          locale="zh-tw"
                          aria-controls="example-input"
                          @context="onContext"
                        ></b-form-datepicker>
                      </b-input-group-append>
                    </b-input-group></div
                ></span>
              </div>
            </td>
          </tr>

          <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>上課時間：星期

                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="inputData.weekArray"
                    value="1"
                    id="inlineCheckbox1"
                  />
                  <label class="form-check-label" for="1">一</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="inputData.weekArray"
                    value="2"
                    id="inlineCheckbox2"
                  />
                  <label class="form-check-label" for="2">二</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="inputData.weekArray"
                    value="3"
                    id="inlineCheckbox3"
                  />
                  <label class="form-check-label" for="3">三</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="inputData.weekArray"
                    value="4"
                    id="inlineCheckbox4"
                  />
                  <label class="form-check-label" for="4">四</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="inputData.weekArray"
                    value="5"
                    id="inlineCheckbox5"
                  />
                  <label class="form-check-label" for="5">五</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="inputData.weekArray"
                    value="6"
                    id="inlineCheckbox6"
                  />
                  <label class="form-check-label" for="6">六</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="inputData.weekArray"
                    value="7"
                    id="inlineCheckbox7"
                  />
                  <label class="form-check-label" for="7">日</label>
                </div>

                <input
                  type="Number"
                  class="form-control"
                  v-model="inputData.stime"
                  ref="inputData.stime"
                  placeholder="0800"
                  oninput="if(value.length>4)value=value.slice(0,4)"
                />~
                <input
                  type="Number"
                  class="form-control"
                  v-model="inputData.etime"
                  ref="inputData.etime"
                  placeholder="1700"
                  oninput="if(value.length>4)value=value.slice(0,4)"
                />
              </div>
            </td>
          </tr>
          <tr align="left">
            <td>
              <div>
                <span class="red_star">＊</span>上課時數:
                <input
                  type="Number"
                  class="form-control"
                  v-model="inputData.courseHours"
                  ref="inputData.courseHours"
                  placeholder="上課時數"
                />
              </div>
            </td>
          </tr>
          <tr align="left">
            <td>
              <div>
                <span class="red_star">＊</span>人數限制:
                <input
                  type="Number"
                  class="form-control"
                  v-model="inputData.primaryList"
                  ref="inputData.primaryList"
                  placeholder="人數限制"
                />
              </div>
            </td>
          </tr>
          <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>課程費用:
                <input
                  type="Number"
                  class="form-control"
                  v-model="inputData.courseCost"
                  ref="inputData.courseCost"
                  placeholder="課程費用"
                />
              </div>
            </td>
          </tr>
          <tr align="left">
            <td>
              <div>
                <span class="red_star">＊</span>上課地點:
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                    v-model="inputData.courseAddr"
                    :options="options2"
                    :aria-describedby="ariaDescribedby"
                    name="radio-inline"
                  ></b-form-radio-group>
                </b-form-group>

                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.courseAddr"
                  :options="options2"
                  placeholder="上課地點"
                />
              </div>
            </td>
          </tr>

          <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>聯絡專線：
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.courseTel"

                  placeholder="0123456789"
                  maxlength="32"
                />
              </div>
            </td>
          </tr>
          <tr align="left">
            <td>
              <div>
                <span class="red_star">＊</span>聯絡Email：
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.email"
                  ref="inputData.email"
                  placeholder="聯絡Email"
                />
              </div>
            </td>
          </tr>

          <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>任課老師：
                <b-form-select
                  text="請選擇任課老師"
                  class="select_text"
                  style="width: 20rem"
                  v-model="inputData.TeacherName"
                >
                  <b-form-select-option
                    v-for="item in getTeacherData"
                    :key="item.tID"
                    :value="item.tID"
                    @click="teacherClick(item.tID, item.name)"
                    >{{ item.name }}
                  </b-form-select-option>
                </b-form-select>
              </div>
            </td>
          </tr>

          <tr align="left">
            <td>
              <div>
                <span class="red_star">＊</span>詳細網址：
                <input
                  type="text"
                  v-model="inputData.link"
                  ref="inputData.link"
                  placeholder="詳細網址"
                />
                <input
                  type="checkbox"
                  id="linkText"
                  v-model="linkText"
                  @click="addLink()"
                  aria-label="Checkbox for following text input"
                />無
              </div>
            </td>
          </tr>
          <tr align="left">
            <td>
              <span class="red_star">＊</span>課程簡介：
              <ckeditor
                :config="config"
                placeholder="請輸入課程簡介"
                v-model="inputData.courseIntroduce"
                ref="inputData.courseIntroduce"
              ></ckeditor>
            </td>
          </tr>
          <tr align="left">
            <td>
              <span class="red_star">＊</span>上傳輪播圖片
              <div class="input-group-text">
                <input
                  type="radio"
                  name="carousel"
                  value="false"
                  checked
                  @click="carouseChang(0)"
                  v-model="inputData.Carousel"
                  aria-label="Radio button for following text input"
                />無

                <input
                  type="radio"
                  name="carousel"
                  value="true"
                  @click="carouseChang(1)"
                  v-model="inputData.Carousel"
                  aria-label="Radio button for following text input"
                />有
              </div>
            </td>
          </tr>
          <tr align="left" v-if="mode">
            <td>
              <div>
                <b-form-file
                  class="mb-2"
                  ref="file-input"
                  :no-drop="true"
                  :no-traverse="true"
                  v-model="file[0]"
                  @input="fileChange(0)"
                  placeholder="上傳輪播圖片"
                  accept="image/jpeg, image/png, image/gif"
                ></b-form-file>
<p>{{ file[0] ? file[0].name : '' }}</p>
              </div>
 <div slot="tip" class="el-upload__tip">
              上傳之檔案格式：
              <ul style="list-style-type:disc;">
                <li>副檔名.jpg、.png</li>
                <li>檔案含英文字母共計 60 碼為檔名。</li>
                <li>檔案尺寸建議870*350像素，解析度建議150*150dpi，位元深度24，大小不得超過 4MB。</li>
              </ul>
            </div>
            <!-- <b-button variant="warning"
              @click="clearImg()">清除<b-icon icon="trash"/></b-button> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="text-align: center">
      <button
        href="#"
        @click.prevent="AddCourse()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px"
      >
        送出
      </button>
    </div>
  </div>
</template>


<script>
import * as tools from "../tool";
import Ckeditor from "vue-ckeditor2";
export default {
  name: "AddCourse",
  components: {
    Ckeditor,
  },
  data() {


    return {
      mode: false,
      file: [{ name: "", RowId: "" }],
      inputFlag: false,
      selected: null,
      options: [
        { value: "0", text: "" },
        { value: "1", text: "現職人才培育課程" },
        { value: "2", text: "專業證照課程" },
        { value: "3", text: "創客基地課程" },
      ],
      selected2: null,
      options2: [
        { value: "工具機學院大樓3樓 VA302", text: "工具機學院大樓3樓 VA302" },
        { value: "工具機學院大樓4樓 多功能教室VA405",text: "工具機學院大樓4樓 多功能教室VA405"},
	{ value: "", text: "其他教室" },
               ],
      linkText: null,
      total: 0,
      isIE: false,
      getTeacherData: null,
      inputData: {
        attributesClassID: 1,
        courseName: null,
        courseClass: null,
        week: null,
        sdate: null,
        edate: null,
        closeDate: null,
        stime: null,
        etime: null,
        courseHours: null,
        weekArray: [],
        courseIntroduce: null,
        courseCost: null,
        courseAddr: null,
        courseTel: null,
        email: null,
        tID: null,
        teacherName: null,
        primaryList: null,
        link: null,
        Info: [],
        Carousel:0,
        User:null,
      },
      currentPage: 1,
      cid: "",
      pageSize: 10,
      queryInfo: {
        sysId: 0,
      },
      config: {
        toolbar: [
          ["Source", "-", "Preview", "-", "Templates"],
          [
            "Cut",
            "Copy",
            "Paste",
            "PasteText",
            "PasteFromWord",
            "-",
            "Undo",
            "Redo",
          ],
          ["Find", "Replace", "-", "SelectAll", "-", ""],
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "-",
            "CopyFormatting",
            "RemoveFormat",
          ],
          [
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Blockquote",
            "CreateDiv",
            "-",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "BidiLtr",
            "BidiRtl",
            "Language",
          ],
          ["Link", "Unlink", "Anchor"],
          [
            "Image",
            "Table",
            "HorizontalRule",
            "Smiley",
            "SpecialChar",
            "PageBreak",
            "Iframe",
          ],
          ["Styles", "Format", "Font", "FontSize"],
          ["TextColor", "BGColor"],
          ["Maximize", "ShowBlocks"],
          ["About"],
        ],
      },
    };
  },
  computed: {
  user () {
   return this.$store.getters.getUser
   },

  },
  methods: {
    carouseChang(mode){
      if(mode == 0)
      {
        this.mode =0;
        this.inputData.Carousel = 0;

      }
      else
      {
 this.mode =1;
        this.inputData.Carousel = 1;


      }


    },
    //  clearImg() {
    //   if (!tools.isNullOrWhiteSpace(this.inpData.headerFile[0].codeName)) {
    //     this.inpData.headerFile[0].codeName = '';
    //     this.inpData.headerFile[0].Status = 'C';
    //   }
    //   this.$refs["file-input"].reset();
    // },
    fileChange(index) {
      var vm = this;
      this.formData = new FormData();
      //  this.formData.delete("header");
      if (index == 0) this.formData.append("header", this.file[0]);

      this.$http
        .post("./WebApi/Common/UploadV2", this.formData)
        .then((response) => {
          if (!tools.isNull(response.data)) {
            if (index == 0) {
              this.file[0] = response.data[0];

            this.inputData.Info.push(response.data[0]);
              //  vm.inpData.headerFile[0].codeName = vm.file[0].tempName;
              //  vm.inpData.headerFile[0].Status = 'C';
            }
          } else {
            tools.showAlert(vm, "danger", "上傳檔案失敗，請重新上傳" + error);
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗，請重新上傳" + error);
        });
    },
    UpdateCid() {
      this.inputData.attributesClassID = this.selected;
      this.inputData.courseClass = this.options[this.selected].text;
    },
    empty(str) {
      if (
        typeof str == "undefined" ||
        !str ||
        str.length === 0 ||
        str === "" ||
        !/[^\s]/.test(str) ||
        /^\s*$/.test(str)
      ) {
        return true;
      } else {
        return false;
      }
    },
    teacherClick(tID, name) {
      this.inputData.tID = tID;
      this.inputData.name = name;
    },
    addLink() {
      if (document.getElementById("linkText").checked == true)
        this.inputData.link = "無";
      else this.inputData.link = null;
    },

    checkInput() {
      this.inputFlag = false;
      if (this.empty(this.selected)) {
        alert("請選擇課程類別");
        this.$refs["selected"].focus();
        this.inputFlag = true;
        return;
      }

      if (this.empty(this.inputData.courseName)) {
        alert("請輸入課程名稱");
        this.$refs["inputData.courseName"].focus();
        this.inputFlag = true;
        return;
      }

      if (this.empty(this.inputData.sdate)) {
        alert("請輸入課程開始日期");
        this.$refs["inputData.sdate"].focus();
        this.inputFlag = true;
        return;
      }
      if (this.empty(this.inputData.edate)) {
        alert("請輸入課程結束日期");
        this.$refs["inputData.edate"].focus();
        this.inputFlag = true;
        return;
      }
      if (this.empty(this.inputData.closeDate)) {
        alert("請輸入報名截止日期");
        this.$refs["inputData.closeDate"].focus();
        this.inputFlag = true;
        return;
      }
      if (this.empty(this.inputData.weekArray)) {
        alert("請輸入上課時間：星期幾");
        this.$refs["inputData.weekArray"].focus();
        this.inputFlag = true;
        return;
      }
      if (this.empty(this.inputData.stime)) {
        alert("請輸入課程開始時間");
        this.$refs["inputData.stime"].focus();
        this.inputFlag = true;
        return;
      }
      if (this.empty(this.inputData.etime)) {
        alert("請輸入課程結束時間");
        this.$refs["inputData.etime"].focus();
        this.inputFlag = true;
        return;
      }
      if (this.empty(this.inputData.courseHours)) {
        alert("請輸入課程總時數");
        this.$refs["inputData.courseHours"].focus();
        this.inputFlag = true;
        return;
      }
      if (this.empty(this.inputData.primaryList)) {
        alert("請輸入人數限制:");
        this.$refs["inputData.primaryList"].focus();
        this.inputFlag = true;
        return;
      }
      if (this.empty(this.inputData.courseCost)) {
        alert("請輸入課程費用");
        this.$refs["inputData.courseCost"].focus();
        this.inputFlag = true;
        return;
      }
      if (this.empty(this.inputData.courseAddr)) {
        alert("請輸入上課地點");
        this.$refs["inputData.courseAddr"].focus();
        this.inputFlag = true;
        return;
      }
      if (this.empty(this.inputData.courseTel)) {
        alert("請輸入聯絡專線");
        this.$refs["inputData.courseTel"].focus();
        this.inputFlag = true;
        return;
      }
      if (this.empty(this.inputData.email)) {
        alert("請輸入聯絡Email");
        this.$refs["inputData.email"].focus();
        this.inputFlag = true;
        return;
      }
      if (this.empty(this.inputData.link)) {
        alert("請輸入詳細網址");
        this.$refs["inputData.link"].focus();
        this.inputFlag = true;
        return;
      }
      if (this.inputData.courseIntroduce == null) {
        alert("請輸入課程簡介");
        this.$refs["inputData.courseIntroduce"].focus();
        this.inputFlag = true;
        return;
      }
        if (this.inputData.Carousel == 1 && this.empty(this.file[0])) {
        alert("請上傳輪播圖片");
        this.$refs["file-input"].focus();
        this.inputFlag = true;
        return;
      }

    },
    AddCourse() {
      this.checkInput();
      this.inputData.User=this.user.id;
      let vm = this;
      if (vm.inputFlag != true) {
        this.$http
          .put("./WebApi/ociaRep/SetociaAddCourse/", this.inputData)
          .then((response) => {
            if (0 < response.data) {
              tools.showAlert(vm, "success", "增加課程成功");
              this.close();
            } else {
              tools.showAlert(vm, "danger", "對不起,增加課程失敗");
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      }
    },
    onContext(ctx) {
      // this.inputData.sdate = ctx.selectedYMD; //Selected: '2022-02-22'
    },

    close() {
      this.$emit("hideModal");
    },
    getTeacherList() {
      let vm = this;
      this.$http
        .get("./WebApi/ociaRep/GetociaTeacherList/")
        .then((response) => {
          if (0 < response.data.length) {
            this.getTeacherData = response.data;
          this.inputData.tID = this.getTeacherData[0].tid;
          this.inputData.teacherName = this.getTeacherData[0].name;
          } else {
            tools.showAlert(vm, "danger", "對不起,取得老師名單失敗");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
        });
    },
  },
  created() {
    console.log("======created addcourseView =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;

   // let vm = this;
    this.getTeacherList();

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
